<template>
	<section class="section-calendar">
        <div class="filter-wrapper top">
            <div class="w-100 d-flex justify-content-start">
                <el-button size="small" type="success" @click="openTaskModal()">Create Task</el-button>
                <el-button style="margin-left: 10px" size="small" type="primary" @click="getTasks(true)">Reload Tasks</el-button>
                <el-select v-model="filter" @change="getTasks(true)" style="margin-left: 10px; width: 250px" size="small">
                    <el-option v-for="item in options.filter" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select
                    v-if="showFilterByBroker"
                    style="margin-left: 10px; width: 250px"
                    size="small"
                    v-model="filterBroker"
                    clearable
                    filterable
                    placeholder="Filter by Broker">
                    <el-option-group v-for="group in brokerList" :key="group.label" :label="group.label">
                        <el-option v-for="item in group.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-option-group>
                </el-select>
            </div>
        </div>
        <div class="calendar-wrapper" style="min-height: 500px" v-loading="calendarLoading">
            <full-calendar ref="fullCalendar" :options="calendarOptions"></full-calendar>
        </div>
        <div class="filter-wrapper bottom">
            <div class="w-100 d-flex justify-content-start">
                <el-button size="small" type="success" @click="openTaskModal()">Create Task</el-button>
                <el-button style="margin-left: 10px" size="small" type="primary" @click="getTasks(true)">Reload Tasks</el-button>
                <el-select v-model="filter" style="margin-left: 10px; width: 250px" size="small">
                    <el-option v-for="item in options.filter" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
        </div>
        <create-task-modal :token="token" :visible.sync="visible" :create.sync="create" :task="taskForm" :application-id="applicationId"></create-task-modal>
    </section>
</template>

<script>
	import { mapGetters } from "vuex"
    import CreateTaskModal from "@ambition/components/tasks/CreateTaskModal.vue"

	import FullCalendar from "@fullcalendar/vue"
	import dayGridPlugin from "@fullcalendar/daygrid"
	import timeGridPlugin from "@fullcalendar/timegrid"
	import interactionPlugin from "@fullcalendar/interaction"

	export default {
		name: "TasksCalendar",
		components: {
			FullCalendar,
            CreateTaskModal,
		},
		props: {
			token: {
				required: true
			},
            applicationId: {
                required: false
            },
            brokerList: {
                required: false
            },
            teamId: {
				required: false,
			},
            showAllTasks: {
                required: false,
                type: Boolean,
                default: false
            },
		},
		data() {
			return {
                options: {
					filter: [
						{
							label: "My Current Tasks",
							value: "my-current-tasks",
						},
						{
							label: "My Completed Tasks",
							value: "my-completed-tasks",
						},
                        {
							label: "My Overdue Tasks",
							value: "my-overdue-tasks",
						},
					],
				},
                filterBroker: null,
                create: true,
                filter: "my-current-tasks",
				taskForm: {},
				visible: false,
				loading: false,
                search: "",
				searchTimeout: null,
				searchTimeoutWait: 1000,
                calendarLoading: true,
				calendarOptions: {
                    allDaySlot: false,
					plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
					initialView: "dayGridMonth",
                    headerToolbar: {
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay'
                    },
                    eventClick: this.handleEventClick,
                    dateClick: this.handleDateClick,
                    events: []
				},
			}
		},

		computed: {
			...mapGetters({
				user: "user/user",
				tasks: "tasks/getCalendarTasks",
			}),
            showFilterByBroker() {
                return ['all-current-tasks', 'all-completed-tasks'].includes(this.filter) ? true : false
            }
		},

		mounted() {
            // get tasks on mount
			this.getTasks(true)
            // if admin, manager or override give the ability to see all current and completed tasks 
			if (Ambition.hasRoleOrPermission(["administrator", "manager"]) || this.showAllTasks) {
                this.filter = "all-current-tasks"
				this.options.filter = [
                    ...[
						{ label: "All Current Tasks", value: "all-current-tasks" },
						{ label: "All Completed Tasks", value: "all-completed-tasks" },
						{ label: "All Overdue Tasks", value: "all-overdue-tasks" },
					],
					...this.options.filter,
				]
			}
        },

		methods: {
            getTasks() {
				this.calendarLoading = true
				let data = {
                    brokerId: this.filterBroker,
                    applicationId: this.applicationId,
                    search: this.search,
					filter: this.filter,
                    calendar: true
				}

                this.$store.dispatch('tasks/setTasks', data).then(res => {
                    this.calendarLoading = false
                    let events = this.tasks.map(task => {
                        return {
                            title: task.task_name,
                            date: task.due_date + " " + task.time,
                            data: task
                        }
                    })
                    this.calendarOptions.events = events
                    let calendar = this.$refs.fullCalendar
                    if (typeof calendar !== "undefined") {
                        let calendarApi = calendar.getApi()
                        calendarApi.refetchEvents()
                    }
                }).catch((err) => {
                    console.error(err)
                })
			},
            openTaskModal() {
				this.create = true
				this.taskForm = {}
				this.visible = true
				this.loading = false
			},
            handleDateClick(data) {
                Vue.set(this.taskForm, 'due_date', this.$moment(data.dateStr).format("YYYY-MM-DD"))
                Vue.set(this.taskForm, 'time', this.$moment(data.dateStr).format("HH:mm:ss"))
                this.create = true
                this.visible = true
            },
            handleEventClick(data) {
				this.taskForm = Object.assign({}, data.event.extendedProps.data)
                this.visible = true
                this.create = false
            },
		},
        watch: {
            filter: {
				handler(filter) {
                    if (['my-current-tasks', 'my-completed-tasks'].includes(filter)) {
                        this.filterBroker = null
                    }
					if (this.searchTimeout) clearTimeout(this.searchTimeout)
					this.searchTimeout = setTimeout(() => {
						this.getTasks(true)
					}, this.searchTimeoutWait)
				},
			},
            tasks: {
                handler() {
                    let events = this.tasks.map(task => {
                        return {
                            title: task.task_name,
                            date: task.due_date + " " + task.time,
                            data: task
                        }
                    })
                    this.calendarOptions.events = events
                    let calendar = this.$refs.fullCalendar.getApi()
                    calendar.refetchEvents()
                },
                deep: true
            },
            filterBroker: {
                handler(brokerId) {
                    if (brokerId) {
                        if (this.searchTimeout) clearTimeout(this.searchTimeout)
                        this.searchTimeout = setTimeout(() => {
                            this.getTasks(true, brokerId)
                        }, this.searchTimeoutWait)
                    }
                }
            }
        }
	}
</script>

<style lang="scss" scoped>
    .section-calendar {
        background-color: #f0f3f5;
		border: 1px solid #c2cfd6;
		padding: 10px;

        .filter-wrapper {
            border: 1px solid #dcdfe6;
			border-radius: 5px;
			padding: 10px !important;
            background: #ffffff;

            &.top {
                margin-bottom: 10px;
            }

            &.bottom {
                margin-top: 10px;
            }
        }

        .calendar-wrapper {
            border: 1px solid #dcdfe6;
			border-radius: 5px;
			padding: 10px !important;
            background: #ffffff;

            .el-loading-mask {
                z-index: 9 !important;
            }
        }
    }
</style>
